import React from 'react';
import Rich from './Rich';
import Figure from './Figures';

function statusClass(cell) {
  if (cell.startsWith('Live today')) return ' pp-status pp-status--live';
  if (cell.startsWith('The next step')) return ' pp-status pp-status--next';
  return ' pp-status';
}

export function DataTable({ columns, rows, kind = 'default', className = '' }) {
  return (
    <div className={`pp-table-wrap pp-table-wrap--${kind} ${className}`.trim()}>
      <table className={`pp-table pp-table--${kind}`}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} scope="col">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row[0]}-${row[1]}`}>
              {row.map((cell, j) => {
                const Cell = j === 0 ? 'th' : 'td';
                const status = kind === 'levels' && j === 3;
                return (
                  <Cell key={columns[j]} scope={j === 0 ? 'row' : undefined} data-label={columns[j]}>
                    {status ? (
                      <span className={statusClass(cell).trim()}>
                        <Rich text={cell} />
                      </span>
                    ) : (
                      <Rich text={cell} />
                    )}
                  </Cell>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function ListItems({ items }) {
  return items.map((item) =>
    typeof item === 'string' ? (
      <li key={item}>
        <Rich text={item} />
      </li>
    ) : (
      <li key={item.text}>
        <Rich text={item.text} />
        <ul className="pp-list pp-list--sub">
          <ListItems items={item.items} />
        </ul>
      </li>
    ),
  );
}

export function Block({ block }) {
  switch (block.t) {
    case 'p':
      return (
        <p className="pp-p">
          <Rich text={block.text} />
        </p>
      );
    case 'callout':
      return (
        <p className="pp-callout">
          <Rich text={block.text} />
        </p>
      );
    case 'quote':
      return (
        <blockquote className="pp-quote">
          <p>
            <Rich text={block.text} />
          </p>
        </blockquote>
      );
    case 'h3':
      return <h3 className="pp-h3">{block.text}</h3>;
    case 'formula':
      return (
        <p className="pp-formula">
          <Rich text={block.text} />
        </p>
      );
    case 'ul':
      return (
        <ul className="pp-list">
          <ListItems items={block.items} />
        </ul>
      );
    case 'ol':
      return (
        <ol className="pp-list pp-list--num">
          <ListItems items={block.items} />
        </ol>
      );
    case 'table':
      return <DataTable columns={block.columns} rows={block.rows} kind={block.kind} className="pp-wide" />;
    case 'figure':
      return <Figure kind={block.key} className="pp-wide" />;
    default:
      return null;
  }
}

export default function Blocks({ blocks }) {
  return blocks.map((block, i) => <Block key={`${block.t}-${i}`} block={block} />);
}
